import { ActionTypes, IParentProps } from './types';

export const resultData = {
  content: '',
  created_at: '2024-04-21T17:42:25.760668+05:30',
  feedback: { like: 0, dislike: 0 },
  id: 320,
  last_edited_on: null,
  liked: null,
  navigation_id: 'b9790adf-020f-4f95-8fc2-f8537609c1x5',
  parent: null,
  post: 645,
  reply_count: 1,
  reported: false,
  updated_at: '2024-04-21T17:42:25.760706+05:30',
  username: 'cleartax',
};

export const CommentTemplate: IParentProps = {
  count: 2,
  next: null,
  previous: null,
  total_count: 27,
  results: [resultData],
};

export const CommentTemplateTestData: IParentProps = {
  count: 2,
  next: null,
  previous: null,
  total_count: 27,
  results: [
    {
      content: 'Cleartax comment test',
      created_at: '2024-04-21T17:42:25.760668+05:30',
      feedback: { like: 0, dislike: 0 },
      id: 320,
      last_edited_on: null,
      liked: null,
      navigation_id: 'b9790adf-020f-4f95-8fc2-f8537609c1x5',
      parent: null,
      post: 645,
      reply_count: 0,
      reported: false,
      updated_at: '2024-04-21T17:42:25.760706+05:30',
      username: 'cleartax',
    },
    {
      content: 'Cleartax comment test',
      created_at: '2024-04-21T17:42:25.760668+05:30',
      feedback: { like: 0, dislike: 0 },
      id: 320,
      last_edited_on: null,
      liked: null,
      navigation_id: 'b9790adf-020f-4f95-8fc2-f8537609c1x5',
      parent: null,
      post: 645,
      reply_count: 1,
      reported: false,
      updated_at: '2024-04-21T17:42:25.760706+05:30',
      username: 'cleartax',
    },
  ],
};

export const titleList = {
  [ActionTypes.CreateParentComment]: 'Add a comment',
  [ActionTypes.CreateRepliesComment]: '',
  [ActionTypes.EditComment]: '',
};
